import { IconProps } from './types';

export const TextIcon = ({ stroke, ...props }: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 38.458 47.073'>
    <g transform='translate(-4 -1)'>
      <path
        // eslint-disable-next-line max-len
        d='M27.536,3H10.307A4.307,4.307,0,0,0,6,7.307V41.765a4.307,4.307,0,0,0,4.307,4.307H36.151a4.307,4.307,0,0,0,4.307-4.307V15.922Z'
        stroke={stroke || '#000'}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='4'
        {...props}
      />
      <path
        d='M21,3V15.922H33.922'
        transform='translate(6.536)'
        stroke='#000'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        {...props}
      />
      <path
        d='M29.229,19.5H12'
        transform='translate(2.615 7.19)'
        stroke='#000'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
        {...props}
      />
      <path
        d='M29.229,25.5H12'
        transform='translate(2.615 9.804)'
        stroke='#000'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
        {...props}
      />
      <path
        d='M16.307,13.5H12'
        transform='translate(2.615 4.575)'
        stroke='#000'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='3'
        {...props}
      />
    </g>
  </svg>
);
